<template>
  <div class="fromulaDetail-box">
    <div class="fromulaDetail-warp">
      <div class="top-warp">
        <div>
          <custom-button icon="el-icon-arrow-left" @click="goBack">返回</custom-button>
        </div>
        <div>
          <!-- <custom-button v-if="orderInfo.status == '4' && computeShowRefundDrug" @click="refundDrug">退药</custom-button> -->
          <custom-button v-if="orderInfo.status == '4' && !(orderInfo.transferOrderStatus == '1' && orderInfo.deptId != nowDeptId)" @click="refundDrug">退药</custom-button>
          <!-- <custom-button v-if="orderInfo.status == '4' && computeShowCancelRefundDrug" -->
          <custom-button v-if="orderInfo.status == '4' && !(orderInfo.transferOrderStatus == '1' && orderInfo.deptId != nowDeptId)" @click="cancelRefundDrug">取消退药</custom-button>
          <el-dropdown class="ml8" @command="handleCommand">
            <custom-button>打印</custom-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="1">收费小票</el-dropdown-item>
              <el-dropdown-item command="2">处方</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <div class="fromulaDetail-content">
        <div class="content-info">
          <div class="patient-info common-warp">
            <div class="w96">
              <span v-if="patientInfo.sex == '1'" class="iconfont icon-nan colorF54A icon-sex"></span>
              <span v-else class="iconfont icon-nan color1890 icon-sex"></span>
              <span>{{ patientInfo.patientName }}</span>
            </div>
            <div class="w48">{{ patientInfo.sex == '0' ? '男' : '女' }}</div>
            <div class="w48">{{ patientInfo.age }}岁</div>
            <div class="w40">{{ patientInfo.ageMth }}月</div>
            <div class="w126">{{ patientInfo.phone }}</div>
          </div>
          <div class="doctor-info">
            <div class="sale-info-warp common-warp">{{ orderInfo.salesPerson }}</div>
            <div class="doctor-info-warp common-warp">
              <div class="w132">{{ doctorInfo.doctorName }}</div>
              <div v-if="orderInfo.orderSourceType == '0'" class="price-warp">¥{{ doctorInfo.registeredPrice }}</div>
              <div v-else class="price-warp">¥{{ registerPrice }}</div>
            </div>
          </div>
        </div>
        <div class="search-warp common-warp">
          <i class="el-icon-plus"></i>
          输入其他商品或拼音码
        </div>
        <div class="charge-warp common-warp">
          <div class="charge-title">
            <div class="title-left">
              <div class="mr28">收费项目</div>
              <div class="mr16 disabled">
                <el-radio disabled v-model="computedIsProcess" label="1">加工</el-radio>
              </div>
              <div class="disabled">
                <el-radio disabled v-model="computedDelivery" label="1">快递</el-radio>
              </div>
            </div>
            <div class="title-right">
              <div class="w92 tac">单价</div>
              <div class="w52 tac">数量</div>
              <div class="w40 tac">单位</div>
              <div class="w92 tac">小计</div>
              <div class="w64 tac">备注</div>
            </div>
          </div>
          <!-- 挂号费、加工费、快递费 -->
          <div class="project-item" v-if="registerPrice || isProcessing == '1' || isDelivery == '1'">
            <!-- <div class="charge-item disabled" v-if="registerPrice && orderInfo.orderSourceType != '0'">
              <div class="iconfont w32 tac flex-sh  color9AA0 icon-yishengg"></div>
              <div class="flex-sh w72 tac">挂号费</div>
              <div class="width-100">医生：{{ doctorInfo.doctorName }}</div>
              <div class="box-warp w92">{{ registerPrice }}</div>
              <div class="box-warp w52">1</div>
              <div class="box-warp w40">次</div>
              <div class="box-warp w92">{{ registerPrice }}</div>
              <div class="remark-warp w64" style="width:64px">{{ remark }}</div>
            </div> -->
            <div class="charge-item disabled" v-for="(item) in computedProcess" :key="item.recipeId">
              <div class="iconfont w32 tac flex-sh color9AA0 icon-jiag"></div>
              <div class="tac w72 flex-sh">加工费</div>
              <div class="width-100 display-f align-i-c">中药处方{{ item.orderNum }}：{{ item.process.processName }}，{{
                item.doseNum }}剂 <div class="refund-warp" v-if="item.process.returnQuantity > 0">{{
                  item.isYlcp == '1' ? `已退${item.process.returnQuantity}剂`:'已退费' }}</div>
              </div>
              <div class="box-warp w92">{{ item.process.processPrice }}</div>
              <div class="box-warp w52">{{ item.isYlcp=='1'? item.doseNum:1}}</div>
              <div class="box-warp w40">次</div>
              <div class="box-warp w92">{{ item.isYlcp == '1' ? computedMultiplication(item.doseNum,
                item.process.processPrice) : item.process.processPrice }}</div>
              <div class="remark-warp" style="width:64px">{{ item.remark }}</div>

            </div>
            <div class="charge-item disabled" v-if="isDelivery == '1'">
              <div class="iconfont w32 tac flex-sh color9AA0 icon-kuaidi"></div>
              <div class="tac w72 flex-sh">快递费</div>
              <div class="width-100 display-f">
                <span class="text-overflow" style="max-width: 260px;">{{ deliveryObj.addressDetail }}</span>
                <!-- <span class="iconfont icon-bianj"></span> -->
              </div>
              <div class="box-warp w92">{{ deliveryObj.price }}</div>
              <div class="box-warp w52">1</div>
              <div class="box-warp w40">次</div>
              <div class="box-warp w92">{{ deliveryObj.price }}</div>
              <div class="remark-warp" style="width:64px">{{ remark }}</div>
            </div>
          </div>
          <!-- 非处方项目 -->
          <div class="project-item disabled" v-for="item in   computedRecipes('0')  " :key="item.recipeId">
            <div v-if="item.items.length > 0">
              <div class="item-title">非处方项目</div>
              <div class="charge-item" v-for="(obj, itemIndex) in   item.items  " :key="obj.paymentRecipeItemId">
                <div class="w32 tac flex-sh  border-r-dash">{{ itemIndex + 1 }}</div>
                <div
                  :class="orderInfo.orderPayFlag == '0' && obj.itemNum > obj.inventory ? 'width-100 warning' : 'width-100'">
                  <span :class="orderInfo.orderPayFlag == '0' && obj.itemNum > obj.inventory ? 'warning' : ''">{{
                    obj.itemName }}</span>
                  <span :class="orderInfo.orderPayFlag == '0' && obj.itemNum > obj.inventory ? ' warning' : ''"
                    class="color6671 ml8 size13">{{ obj.specifications || '' }}</span>
                  <el-tooltip v-if="orderInfo.orderPayFlag == '0' && obj.itemNum > obj.inventory" class="item"
                    effect="dark" content="库存不足" placement="top">
                    <span class="iconfont icon-jingg colorFE8F ml8"></span>
                  </el-tooltip>
                  <span class="refund-warp" v-if="obj.returnQuantity > 0">已退{{ obj.returnQuantity }}{{ obj.itemUnit
                    }}</span>
                </div>
                <div class="box-warp w92">{{ obj.price }}</div>
                <div class="number-warp disabled">{{ obj.itemNum }}</div>
                <div class="box-warp w40">{{ obj.itemUnit }}</div>
                <div class="box-warp w92">{{ obj.totalPrice }}</div>
                <div class="disabled remark-warp" style="width:64px">{{ obj.remark }}</div>
              </div>
            </div>
          </div>
          <!-- 中药处方 -->
          <div class="project-item disabled" v-for="(  item  ) in   computedRecipes('1')  "
            :key="item.paymentRecipeItemId">
            <div class="item-title">
              <div>中药处方{{ item.orderNum }}</div>
              <div v-if="item.isYlcp && item.isYlcp == '1'" class="combo-icon">医联</div>
              <div v-if="item.isYlcp && item.isYlcp == '1'" class="color1F23">【{{ item.recipeName }}】</div>
            </div>
            <div v-if="item.isYlcp && item.isYlcp == '0'">
              <div class="charge-item disabled" v-for="(  obj, itemIndex  ) in   item.items  " :key="obj.drugId">
                <div class="w32 tac flex-sh  border-r-dash">{{ itemIndex + 1 }}</div>
                <div
                  :class="(computedMultiplication(item.doseNum, obj.itemNum) > obj.inventory) && orderInfo.orderPayFlag == '0' ? 'width-100 warning' : 'width-100'">
                  <span
                    :class="(computedMultiplication(item.doseNum, obj.itemNum) > obj.inventory) && orderInfo.orderPayFlag == '0' ? 'warning' : ''">{{
                    obj.itemName }}</span>
                  <span class="color6671 ml8 size13" v-if="item.ybCenterDrugDirectoryCategorySign">【{{
                    item.ybCenterDrugDirectoryCategorySign }}】</span>
                  <el-tooltip v-if="(computedMultiplication(item.doseNum, obj.itemNum) > obj.inventory) && orderInfo.orderPayFlag == '0'"
                    class="item" effect="dark" content="库存不足" placement="top">
                    <span class="iconfont icon-jingg colorFE8F ml8"></span>
                  </el-tooltip>
                  <span class="refund-warp" v-if="obj.returnQuantity > 0">已退{{ computeDoseNum(obj) }}剂{{ obj.itemNum
                    }}{{
                    obj.
                    itemUnit }}</span>
                </div>
                <div class="box-warp w92">{{ obj.price }}</div>
                <div class="number-warp ">{{ obj.itemNum }}</div>
                <div class="box-warp w40">{{ obj.itemUnit }}</div>
                <div :class="obj.isOwned=='1'?'box-warp w92 colorFE8F':'box-warp w92'">{{ obj.isOwned=='1' ? '自备' : obj.totalPrice }}</div>
                <div class="remark-warp" style="width:64px">{{ obj.remark }}</div>
              </div>
            </div>
            <div class="drug-warp-total disabled">
              <div class="drug-action">
                <div class="dosage-warp">
                  <div class="mr8">{{ item.doseNum }}</div>
                  <div>剂</div>
                </div>
                <div class="ml24">{{ item.items.length }}味，单剂{{ item.weight }}g，合计{{
                  computedMultiplication(item.doseNum, item.weight) }}g</div>
              </div>
              <div>总价：¥{{ item.totalPrice }}</div>
            </div>
          </div>
          <!-- 中成药 -->
          <div class="project-item disabled" v-for="(  item  ) in   computedRecipes('4')  "
            :key="item.paymentRecipeItemId">
            <div class="item-title">
              <div>中成药处方{{ item.orderNum }}</div>
            </div>
              <div class="charge-item disabled" v-for="(  obj, itemIndex  ) in   item.items  " :key="obj.drugId">
                <div class="w32 tac flex-sh  border-r-dash">{{ itemIndex + 1 }}</div>
                <div
                  :class="(computedMultiplication(item.doseNum, obj.itemNum) > obj.inventory) && orderInfo.orderPayFlag == '0' ? 'width-100 warning' : 'width-100'">
                  <span
                    :class="(computedMultiplication(item.doseNum, obj.itemNum) > obj.inventory) && orderInfo.orderPayFlag == '0' ? 'warning' : ''">{{
                    obj.itemName }}</span>
                  <span class="color6671 ml8 size13" v-if="item.ybCenterDrugDirectoryCategorySign">【{{
                    item.ybCenterDrugDirectoryCategorySign }}】</span>
                  <el-tooltip v-if="(computedMultiplication(item.doseNum, obj.itemNum) > obj.inventory) && orderInfo.orderPayFlag == '0'"
                    class="item" effect="dark" content="库存不足" placement="top">
                    <span class="iconfont icon-jingg colorFE8F ml8"></span>
                  </el-tooltip>
                  <span class="refund-warp" v-if="obj.returnQuantity > 0">已退{{ computeDoseNum(obj) }}剂{{ obj.itemNum
                    }}{{
                    obj.
                    itemUnit }}</span>
                </div>
                <div class="box-warp w92">{{ obj.price }}</div>
                <div class="number-warp ">{{ obj.itemNum }}</div>
                <div class="box-warp w40">{{ obj.itemUnit }}</div>
                <div class="box-warp w92">{{ obj.totalPrice }}</div>
                <div class="remark-warp" style="width:64px">{{ obj.remark }}</div>
              </div>
              <div class="physio-total-warp" :class="disabled ? 'disabled ' : ''">总价：¥{{ item.totalPrice }}</div>
          </div>
        </div>
        <div class="search-warp common-warp">{{orderPayment.patientRemark || '患者备注信息'}}</div>
        <div class="search-warp common-warp">{{ orderPayment.deptRemark||'医馆备注信息'}}</div>
      </div>
    </div>
    <refundItemDialog v-if="dialogShow" :dialogShow="dialogShow" @closeDialog="closeDialog" :dialogObj="dialogObj"
      @editDrugSuccess="editDrugSuccess">
    </refundItemDialog>
    <!-- 打印 -->
    <printDialog :printDialogShow="printDialogShow" v-show="printDialogShow" @printSuccessBatch="printSuccessBatch"
      @closePrintPrescription="closePrintPrescription" ref="printDia" @setPrintDiaShow="setPrintDiaShow"
      :isBatch="isBatch" :printListObj="printListObj" :printType="printType" :id="printOrderId"
      :orderType="printorderType">
    </printDialog>
  </div>
</template>
  
<script>
import { Utils } from '@/utils/utils'
import { isEmptyArray, isNull, dictText, isNullObj, debounce, validParams, msgboxWarning } from '@/utils/validateBase'
import { getChargeItem } from '@/api/pricingDetails'
import refundItemDialog from './components/refundItemDialog'
import { computeWeight, computeRecipesTotal, computePricingTotal } from '@/utils/computePrice'
import printDialog from '@/components/printDialog'


export default {
  // 定义引入的组件
  components: { refundItemDialog, printDialog, },
  props: {},
  data() {
    return {
      dialogShow: false,
      dialogObj: {},
      patientInfo: {},
      recipesList: [],
      isProcessing: '',
      isDelivery: '',
      deliveryObj: {},
      registerPrice: '',
      nowDeptId: 0,
      orderInfo: {},
      doctorInfo: {},
      orderPayment: {},
      deliveryObj: {},
      remark: '',
      orderId: '',
      printListObj: [],
      printDialogShow: false,//打印弹框
      printType: '',
      isBatch: false,
      printOrderId: '',
      printorderType: ''
    }
  },

  computed: {
    //处理是否有加工
    computedIsProcess() {
      let index = this.recipesList.findIndex(item => { return item.processFlag == '1' })
      this.isProcessing = Utils.gt(index, -1) ? '1' : '0'
      return Utils.gt(index, -1) ? '1' : '0'
    },
    //处理是否配送
    computedDelivery() {
      this.isDelivery = (isNull(this.deliveryObj) || isNullObj(this.deliveryObj)) ? '0' : '1'
      return (isNull(this.deliveryObj) || isNullObj(this.deliveryObj)) ? '0' : '1'
    },
    //处理有加工的中药处方
    computedProcess() {
      return this.recipesList.filter(item => { return item.recipeType == '1' && item.processFlag == '1' })
    },
    //处理处方数据
    computedRecipes() {
      let that = this
      return function (type) {
        return this.recipesList.filter(item => { return item.recipeType == type })
      }
    },
    //处理已退剂量
    computeDoseNum() {
      let that = this
      return function (obj) {
        return this.$bigNumber(isNull(obj.returnQuantity) ? 0 : obj.returnQuantity, '/', obj.itemNum)
      }
    },
    //判断是否显示退药按钮
    computeShowRefundDrug() {
      let list = []
      this.recipesList.forEach(item => {
        item.doseNum = isNull(item.doseNum) ? 1 : item.doseNum
        if (item.recipeType != '3') {
          if (item.processFlag == '1') {
            list.push({
              ...item.process,
              returnQuantity: isNull(item.process.returnQuantity) ? 0 : item.process.returnQuantity,
              totalNum: 1
            })
          }
          item.items && item.items.forEach(obj => {
            obj.totalNum = this.$bigNumber(item.doseNum, '*', obj.itemNum)
            obj.returnQuantity = isNull(obj.returnQuantity) ? 0 : obj.returnQuantity
            list.push(obj)
          })
        }
      })
      return list.some(item => { return Utils.gt(item.totalNum, item.returnQuantity) })
    },
    //判断是否显示取消退药按钮
    computeShowCancelRefundDrug() {
      let list = []
      this.recipesList.forEach(item => {
        if (item.recipeType != '3') {
          if (item.processFlag == '1') list.push({ ...item.process, returnQuantity: isNull(item.process.returnQuantity) ? 0 : item.process.returnQuantity })
          item.items && item.items.forEach(obj => {
            obj.returnQuantity = isNull(obj.returnQuantity) ? 0 : obj.returnQuantity
            list.push(obj)
          })
        }
      })
      return list.some(item => { return Utils.gt(item.returnQuantity, 0) })
    },
    //乘法
    computedMultiplication() {
      let that = this
      return function (a, b) {
        if (isNull(a) || isNull(b)) return
        return this.$bigNumber(a, '*', b)
      }
    },
  },
  //变量监听
  watch: {},
  // 页面初始化
  created() {
    let orderId = this.$route.query.orderId
    this.orderId = orderId
    this.nowDeptId = Number(sessionStorage.getItem('deptId'))
    if (!isNull(orderId)) {
      this.getChargeItem()
    }
  },
  // 页面DOM加载完成
  mounted() { },
  //离开页面时执行
  destroyed() { },
  // 页面方法
  methods: {

    /**
    * 取消打印
    */
    closePrintPrescription() {
      this.printDialogShow = false
    },
    setPrintDiaShow() {
      this.printDialogShow = true
    },
    printSuccessBatch() {
      this.$message.success('打印成功')
    },
    /**
     * 退药成功
     */
    editDrugSuccess() {
      this.getChargeItem()
      this.dialogShow = false
    },

    /**
     * 打印
     * val 1小票 2处方
     */
    handleCommand(val) {
      this.printType = val
      switch (val) {
        case '1':
          this.isBatch = false
          this.printorderType = '4'
          this.printOrderId = this.orderId
          this.$nextTick(() => {
            this.$refs.printDia.useDefaultPrint()
          })
          break;
        case '2':
          this.isBatch = true
          let printListObj = []
          this.recipesList.forEach(item => {
            if (item.recipeType != '0') {
              printListObj.push({
                printType: val,
                id: item.recipeId,
                orderType: item.recipeType == '3' ? '2' : '1'
              })
            }
          })
          this.printListObj = printListObj
          this.$nextTick(() => {
            this.$refs.printDia.useDefaultPrint()
          })
          break;
      }
    },

    /**
     * 退药
     */
    refundDrug() {
      this.dialogShow = true
      this.dialogObj.type = 0
      this.dialogObj.orderId = this.orderId
    },
    /**
     * 取消退药
     */
    cancelRefundDrug() {
      this.dialogShow = true
      this.dialogObj.type = 1
      this.dialogObj.orderId = this.orderId
    },
    /**
     * 关闭弹框
     */
    closeDialog() {
      this.dialogShow = false
    },
    /**
     * 返回
     */
    goBack() {
      this.$router.replace(`/formula/formulalist?back=${1}`);
    },
    /**
     * 查询收费项目信息
     */
    getChargeItem() {
      return new Promise(async (resolve, reject) => {
        let { code, data } = await getChargeItem({ orderId: this.orderId })
        resolve(code)
        if (code == 200) {
          this.registerPrice = 0
          if (isNull(data.orderDetail.patient)) {
            this.patientInfo = {
              patientName: '',
              phone: '',
              yaer: '',
              month: '',
              sex: ''
            }
          } else {
            this.patientInfo = data.orderDetail.patient
            this.$computeAge(Utils.timeFormat(this.patientInfo.birthday), this.patientInfo);
          }
          this.deliveryObj = isNull(data.delivery) ? {} : data.delivery;
          if (!isNull(this.deliveryObj) && !isNullObj(this.deliveryObj)) {
            let { provinceName, cityName, regionName, scopeName, detailedAddress, consigneeName, phone } = this.deliveryObj
            this.deliveryObj.addressDetail = `${provinceName}${cityName}${regionName}${isNull(scopeName) ? '' : scopeName}${detailedAddress}(${consigneeName}${phone})`
          }
          this.orderPayment = isNull(data.orderPayment) ? {} : data.orderPayment
          this.doctorInfo = isNull(data.orderDetail) ? {} : (isNull(data.orderDetail.doctor) ? {} : data.orderDetail.doctor)
          this.orderInfo = isNull(data.orderDetail) ? {} : data.orderDetail.order
          this.recipesList = isNull(data.paymentRecipes) ? [] : data.paymentRecipes.filter(item => { return item.recipeType != '3' })
          if (this.orderInfo.orderSourceType != '0') {
            this.registerPrice = this.doctorInfo.registeredPrice
          }
          this.computeWeightAndTotal(this.recipesList);
        } else {
          this.registerPrice = 0
        }
      })
    },
    /**
   * 计算重量和价格
   */
    computeWeightAndTotal(list) {
      computeWeight(list, this);
      computeRecipesTotal(list, this);
      computePricingTotal(this)
    },

  },
}
</script>
<style lang="less" scoped src="./FormulaDetails.less"></style>